import React, { useState } from 'react';
import { get } from 'lodash';
import Metrics from 'services/metrics';
import PropTypes from 'prop-types';
import ImageSection from './components/ImageSection';
import InfoSection from './components/InfoSection';
import ExpirationSection from './components/ExpirationSection';
import ButtonSection from './components/ButtonSection';
import DeviceSection from './components/DeviceSection';
import './components/style.scss';

const RentHistory = ({
  className,
  labels,
  item,
  active,
  download,
  onRedirect,
  onModifyDevice,
  onDetachDevice,
  onDetachDevices,
  onShowModal,
  onRemoveModal,
}) => {
  const [show, setShow] = useState(false);
  const handleToggle = e => {
    Metrics.newEvent({
      eventCategory: 'Historial',
      eventAction: e.title,
      eventLabel: 'Dispositivos asociados',
    });
    setShow(!show);
  };
  const offerDesc = get(item, 'purchase.playButton.oneofferdesc', '');
  return (
    <div className={`box-historial padding-2 ${className}`}>
      <div className={`row ${active ? '' : 'no_purchase'}`}>
        <div className="col-xs-12 padding-top-1">
          <ImageSection
            title={item.common.title}
            imgLarge={item.common.image_large}
            imgSmall={item.common.image_medium}
          />
          <InfoSection
            title={item.common.title}
            offerDesc={offerDesc}
            time={item.time}
            price={item.price}
            label={labels}
            gateway={item.gateway_text}
          />
          <ExpirationSection
            download
            label={labels}
            expirationDate={item.expiration_date}
            startDate={item.start_date}
          />
          <ButtonSection
            label={labels}
            active={active}
            download={download}
            content={item.common}
            deviceQuantity={item.device && item.device.length}
            onRedirect={onRedirect}
            onToggle={handleToggle}
          />
        </div>
      </div>
      <DeviceSection
        label={labels}
        deviceQuantity={item.device && item.device.length}
        devices={item.device}
        show={show}
        onToggle={handleToggle}
        onModifyDevice={onModifyDevice}
        onDetachDevice={onDetachDevice}
        onDetachDevices={onDetachDevices}
        onShowModal={onShowModal}
        onRemoveModal={onRemoveModal}
      />
    </div>
  );
};

RentHistory.propTypes = {
  active: PropTypes.bool,
  download: PropTypes.bool,
  labels: PropTypes.object,
  className: PropTypes.string,
  item: PropTypes.object,
  onRedirect: PropTypes.func,
  onModifyDevice: PropTypes.func,
  onDetachDevice: PropTypes.func,
  onDetachDevices: PropTypes.func,
  onShowModal: PropTypes.func,
  onRemoveModal: PropTypes.func,
};
export default RentHistory;
